import { getCurrentUser } from 'vuefire'

export const useApiHeaders = async (internal: boolean = false) => {
  const config = useRuntimeConfig()
  const currentUser = useCurrentUser()
  let token

  try {
    const user = currentUser.value ?? await getCurrentUser()

    if (user) {
      token = await user.getIdToken()
    }
  } catch (error) {
    console.warn('Failed to get user token:', error)
    token = null
  }

  // Check if we have a valid token
  if (!token) {
    throw new Error('User not authenticated. Please log in again.')
  }

  if (internal)
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

  return {
    headers: {
      Authorization: `Bearer ${token}`
    },
    baseURL: config.public.baseUrl
  }
}
